var React = require('react');

function UserIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M14.731 10.157a7.494 7.494 0 0 0-1.911-1.2.625.625 0 1 0-.508 1.142 6.251 6.251 0 0 1 1.594.993 2.492 2.492 0 0 1 .844 1.873v1.156a.626.626 0 0 1-.625.625H1.875a.626.626 0 0 1-.625-.625v-1.152a2.492 2.492 0 0 1 .844-1.869A8.786 8.786 0 0 1 8 9.25a4.63 4.63 0 1 0-2.817-.96 8.689 8.689 0 0 0-3.914 1.866A3.742 3.742 0 0 0 0 12.969v1.156A1.877 1.877 0 0 0 1.875 16h12.25A1.877 1.877 0 0 0 16 14.125v-1.156a3.742 3.742 0 0 0-1.269-2.812zM4.625 4.625A3.375 3.375 0 1 1 8 8a3.379 3.379 0 0 1-3.375-3.375z","transform":"translate(-1547 -39) translate(1547 39)"})));
}

UserIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","className":"user-icon"};

module.exports = UserIcon;

UserIcon.default = UserIcon;
